import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { onDisableWindowScroll, onEnableWindowScroll } from "../../utilities/helper";

const initialState = {
    show: false,
    createYourHoliday: false,
    agentNumber: "",
    agentEmail: "",
    royalInternationalPopup: false,
    status: "idle"
};

export const detailsConfirmationSlice = createSlice({
    name: "detailsConfirmation",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        showHideDetailsConfirmation: (state, action) => {
            state.show = action.payload;
        },
        showHideRoyalInternationalPopup: (state, action) => {
            state.royalInternationalPopup = action.payload;
        },
        handleCreateYourHoliday: (state, action) => {
            state.createYourHoliday = action.payload;
        },
        updateAgentNumber: (state, action) => {
            state.agentNumber = action.payload;
        },
        updateAgentEmail: (state, action) => {
            state.agentEmail = action.payload;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const {
    showHideDetailsConfirmation,
    showHideRoyalInternationalPopup,
    updateAgentNumber,
    updateAgentEmail,
    handleCreateYourHoliday,
    showHideRoyalInternationalCustomerEmailPopup
} = detailsConfirmationSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.buildMyHoliday.value)`
export const selectShowStateDetailsConfirmation = (state) => state.detailsConfirmation.show;
export const selectRoyalInternationalPopup = (state) => state.detailsConfirmation.royalInternationalPopup;
export const selectAgentNumber = (state) => state.detailsConfirmation.agentNumber;
export const selectAgentEmail = (state) => state.detailsConfirmation.agentEmail;
export const selectCreateYourHolidayStatus = (state) => state.detailsConfirmation.createYourHoliday;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const handleStateDetailsConfirmation = (isCreateYourHoliday) => (dispatch, getState) => {
    const { show, createYourHoliday } = getState().detailsConfirmation;
    dispatch(handleCreateYourHoliday(isCreateYourHoliday));
    dispatch(showHideDetailsConfirmation(!show));
};

export default detailsConfirmationSlice.reducer;
